export enum DeviceEnum {
  MOBILE = 1,
  SMALL_TABLET = 2,
  TABLET = 3,
  SMALL_DESKTOP = 4,
  DESKTOP = 5,
  LARGE_DESKTOP = 6,
}
